import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, from} from "rxjs";
 
import {Subscription} from "rxjs"; 
import {delay, map} from 'rxjs/operators';
import * as moment from 'moment';
import { Socket } from 'ngx-socket-io';
import {AnalyticService} from '../shared/services/analytic.service'
import { NbDialogService, NbToastrService } from '@nebular/theme';
 

@Component({
  selector: 'app-statistics-page', 
  templateUrl: './statistics-page.component.html',
  styleUrls: ['./statistics-page.component.scss'],
  
})
export class StatisticsPageComponent implements OnInit, OnDestroy{
 
    lSub$:any;
    statItems:any;
 
  loading:boolean = true;

  constructor(     private analyticService: AnalyticService  ){
  }
   
 
   ngOnInit() {  

    this.lSub$ = this.analyticService.getOverview().subscribe((data) =>{
		this.statItems = data.streams
			 
		this.loading = false 
	})
  
  }


 


   
 
   ngOnDestroy() {
   	if(this.lSub$){
		this.lSub$.unsubscribe()
	}
   }
 
   

 
  
}
